export default {
  core: ['admin/admin.js', 'explorer/explorer.js', 'relay/relay.js', 'settings/settings.js'],
  lite: ['admin/admin.js', 'explorer/explorer.js', 'settings/settings.js']
};